import React from 'react';
import { Link } from 'react-router-dom';
import {
  Row, Col
} from 'react-bootstrap';
import Truncate from 'src/components/truncate';
import dateformat from 'dateformat';
import cx from 'classnames';
import Banner from 'src/legacy/components/Banner';

import _ from "lodash";
import styles from './StreamIcon.module.scss';
import StreamDefaultIcon from 'src/legacy/images/default_stream.png'
import DOMPurify from 'dompurify';

import { localizedStrings } from 'src/localization';

class StreamIcon extends React.Component {
  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons;
    this.localizedKeywords = localizedStrings.keywords;
  }

  render() {

    return (
      <div>
        <Link to={`/streams/${this.props.id}`} className={styles.link}>
          {this._renderStreamIcon()}
        </Link>
      </div>
    );
  }

  _renderStreamIcon() {
    const stream = this.props.stream;

    return (
      <Row className={cx(styles.stream, this.props.className)}>
        <Col md={12} className={styles.paddingRight}>
          <div className={styles.streamContainer}>
            <div>
              {this.renderStreamIcon()}
            </div>
            <div className={styles.descriptionContainer}>
              <div className={styles.name}>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(stream.name) }}></div>
              </div>
              <Col sm={12} className={cx(styles.streamMetrics, styles.noPadding)}>
                <div className={styles.metrics}>
                  <span>{stream.groupCount} {this.localizedKeywords.groups}</span>
                </div>
                <div className={styles.metrics}>
                  <span>{stream.assetsCount} {this.localizedKeywords.assets}</span>
                </div>
              </Col>
              <Col sm={12} className={cx(styles.author, styles.noPadding)}>
                <Truncate lines={2}>{this.localizedCommons.owner}: {this.renderName(stream.createdBy)}</Truncate>
              </Col>
              <Col sm={12} className={cx(styles.date, styles.noPadding, styles.italicText)}>
                <span>{this.localizedCommons.last_update}: {dateformat(stream.modifiedDate, 'dd mmm yyyy')}</span>
              </Col>
            </div>
          </div>
        </Col>
      </Row>
    );
  }

  renderName(user) {
    return `${_.get(user, "firstName", "")} ${_.get(user, "lastName", "")}`
  }


  renderStreamIcon() {
    let iconStyle = {
      width: this.props.iconWidth,
      height: (this.props.iconWidth * 1.1667) + 10
    };

    var banner = _.get(this.props.stream, 'banner', {
      mediaType: 'image',
      background: {
        thumbnail: StreamDefaultIcon,
        full: StreamDefaultIcon
      }
    });

    banner = {
      ...banner,
      filter: null
    }

    return (
      <div className={cx('grid-item', this.props.className)}>
        <div className={styles.icon} style={iconStyle}>
          <Banner value={banner} default={StreamDefaultIcon} />
        </div>
      </div>
    );
  }
}
StreamIcon.defaultProps = {
  iconWidth: 140
};


export default StreamIcon;